module.exports = __webpack_public_path__ + "championsleague_round-4996b0322d80fc5e9c0a98127961d956.png";


//////////////////
// WEBPACK FOOTER
// ./assets/media-images/no/championsleague_round.png
// module id = 1179
// module chunks = 1 2